import config from 'config';

const excludeSetsFplIds = config.get('public.featuredProductLists.hideProduct');
const saleFplIds = config.get('public.saleFpls');
const xtraVipBoxTagId = config.get('public.productTags.xtraVipBox');

export const getWearItWithProducts = (
  product,
  {
    domain = '.com',
    isVip = false,
    maxProducts = 4,
    isSaleItem = false,
    shouldShowSaleItems = true,
  }
) => {
  if (!product.wear_it_with) {
    return [];
  }
  const excludedSetsFplIdByDomain = excludeSetsFplIds[domain];
  const saleFplIdByDomain = isVip
    ? saleFplIds.vip[domain]
    : saleFplIds.lead[domain];

  // in case wear_it_with comes as single object
  let wearItWith = product.wear_it_with;
  if (!Array.isArray(wearItWith)) {
    wearItWith = [wearItWith];
  }

  return wearItWith
    .filter(
      ({
        featured_product_location_id_list: fplLocationIdList = [],
        tag_id_list: tagIdList = [],
      }) => {
        // show both sale and non-sale items in PIW for sale pdps
        // exclude sale items in PIW for non sale pdps
        const conditionForSaleItem = isSaleItem
          ? true
          : !fplLocationIdList.includes(saleFplIdByDomain) ||
            shouldShowSaleItems;

        return (
          !fplLocationIdList.includes(excludedSetsFplIdByDomain) &&
          conditionForSaleItem &&
          !tagIdList.includes(xtraVipBoxTagId)
        );
      }
    )
    .slice(0, maxProducts);
};
